export default "invalid-workshop-link = Steam 창작마당 링크가 아닙니다.\ninvalid-youtube-link = YouTube 링크가 아닙니다.\nrequired = 필수 항목입니다\n"